module.exports = __webpack_public_path__ + "static-v-shop/1786461253957/img/logo_maestro.ced7dab5.png";